import { ConfigurationType, LineSetType } from 'data/types';
import { findConfigurationById } from 'utils/configurations';

export function withConfigurationLinesets(
  configurations: ConfigurationType[],
  configurationId: string,
  lineSets: LineSetType[]
): ConfigurationType[] {
  const configuration = findConfigurationById(configurations, configurationId);
  if (!configuration) return configurations;

  return configurations.map((candidate) =>
    candidate.uniqueId === configurationId
      ? { ...candidate, lineSets }
      : candidate
  );
}
